// extracted by mini-css-extract-plugin
module.exports = {"customAction":"CustomHeaderGlobalAction_customAction__UtqgI","actionText":"CustomHeaderGlobalAction_actionText__EH78W"};